import TitleTabPage from "@magicware/dashboard/navigation/TitleTabPage";
import { useProjectSetupId } from "../../navigation/projectSetups";
import { useAutoDispatchAsyncThunk } from "../../redux/hooks";
import { projectSetupThunks } from "../../redux/projectSetups/projectSetupsReducer";
import { RootState } from "../../redux/types";

export default function ProjectSetupTabPage() {
    const projectSetupId = useProjectSetupId();
    const api = useAutoDispatchAsyncThunk(projectSetupThunks.loadTabInfo, { projectSetupId });
    return (
        <TitleTabPage
            apiStatus={api.apiStatus}
            titleSelector={(state: RootState) => state.projectSetups.tabInfo?.name}
        />
    );
}
